import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Icon from 'wonderbly-components/lib/Icon';
import './Collapsible.scss';

class Collapsible extends Component {
  componentDidMount() {
    this.getDimensions();
    window.addEventListener('resize', this.getDimensions);
  }

  getDimensions() {
    if (!this._wrapper) {
      return;
    }
    const height = this._wrapper.getBoundingClientRect().height;

    this.setState(() => ({
      height,
    }));
  }

  getWrapper = (u) => this._wrapper = u;
  handleToggle = () => this.props.onToggle(this.props.index);

  render() {
    return (
      <div className="collapsible">
        <button className="collapsible-toggle" type="button" onClick={this.handleToggle}>
          <span className="collapsible-toggle-text">{this.props.title}</span>
          <span className={cx('collapsible-toggle-arrow', { 'collapsible-toggle-arrow-open': this.props.isOpen })}>
            <Icon icon="dropdown" />
          </span>
        </button>
        <div
          className={cx('collapsible-content', { 'collapsible-content-open': this.props.isOpen })}
          style={{ maxHeight: this.props.isOpen && this.state.height }}>
          <div className="collapsible-content-wrapper" ref={this.getWrapper}>
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}

Collapsible.propTypes = {
  index: PropTypes.number,
  onToggle: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  children: PropTypes.element.isRequired,
};

export default Collapsible;



// WEBPACK FOOTER //
// ./src/client/js/view/components/Collapsible/Collapsible.js